//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  ADMIN: 'Admin',
  ERROR_CONNECTING_INTERNET: 'You are offline. Trying to reconnect...',
  ONLINE_AGAIN: 'You are back online',
});
